import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Card, CardLabel, DarkCard, Fade, Hi, Slide, SlideHeader } from '../deck/Slide';
const principles = ['One defined job: keep attention alive on the page', 'One standard format across every market', 'Every placement carries a High Value Action'];
export function WhyWhereSlide() {
  return <Slide data-id="element-280" data-mp="3uyirx96bjupq">
      <SlideHeader eyebrow="Defining the how, why, where and what" data-id="element-281" data-mp="3uyabx8ewg9ab">
        A new approach to making engagement high and{' '}
        <Hi data-id="element-282" data-mp="rkfzy6s1o0rs">turning traffic into action.</Hi>
      </SlideHeader>

      <div className="grid min-h-0 flex-1 grid-cols-12 gap-[clamp(1.25rem,2.5vw,2.5rem)]" data-id="element-283" data-mp="rhk3ynzrbm5z">
        <Fade delay={0.2} className="col-span-7 flex" data-id="element-284" data-mp="coqa1xjqn3hs">
          <Card className="flex flex-1 flex-col justify-center" data-id="element-285" data-mp="hkp5u67ebns8">
            <CardLabel data-id="element-286" data-mp="2xcuxgttfbmgu">The goal</CardLabel>
            <p className="mt-3 text-[clamp(1.05rem,1.6vw,1.6rem)] font-semibold leading-snug text-[var(--fg)]" data-id="element-287" data-mp="2xc3au8ht0z2p">
              Move beyond tactical, disconnected content drops to a globally
              standardized engagement strategy.
            </p>
            <ul className="mt-6 space-y-3" data-id="element-288" data-mp="50ddkr5ra4de">
              {principles.map(principle => <li key={principle} className="flex items-start gap-3" data-id="element-289" data-mp="j04w9577w8xq">
                  <ArrowRightIcon className="mt-1 h-4 w-4 flex-shrink-0 text-[var(--brand-green-light)]" aria-hidden="true" data-id="element-290" data-mp="j1g1zak83qrh" />
                  <span className="text-[clamp(0.85rem,1.05vw,1.05rem)] font-medium leading-relaxed text-[var(--muted)]" data-id="element-291" data-mp="swrgbrrpyvyp">
                    {principle}
                  </span>
                </li>)}
            </ul>
          </Card>
        </Fade>

        <Fade delay={0.35} className="col-span-5 flex" data-id="element-292" data-mp="xoixxcswdrcp">
          <DarkCard className="flex flex-1 flex-col justify-center" data-id="element-293" data-mp="xr5ge7hbtr9p">
            <CardLabel tone="light" data-id="element-294" data-mp="1bplkrrrpv5oo">The focus area</CardLabel>
            <p className="mt-2 text-[clamp(3rem,6.5vw,6rem)] font-bold leading-none" data-id="element-295" data-mp="16pz9hnvg7zii">
              85%
            </p>
            <p className="mt-3 text-[clamp(0.95rem,1.3vw,1.3rem)] font-semibold leading-snug" data-id="element-296" data-mp="4d44nojfp16d">
              of revenue sits with corporate and established brands.
            </p>
            <p className="mt-3 text-[clamp(0.85rem,1vw,1rem)] leading-relaxed text-white/70" data-id="element-297" data-mp="dd99bqx8tlgu">
              The same brands that carry the portfolio, without dedicated
              marketers to run engagement day to day.
            </p>
          </DarkCard>
        </Fade>
      </div>
    </Slide>;
}